<template>
  <v-data-table
      :headers="headers"
      :items="schematrons"
      :items-per-page="-1"
      :loading="loading"
      @click:row="$emit('edit', $event)"
  >
    <template v-slot:item.scope="{ item }">
      <v-chip
          :color="scopeColor(item.scope)"
          small
          dark
      >
        {{ item.scope }}
      </v-chip>
      <span
          v-if="item.stateName || item.clientName"
          class="ml-2 grey--text text--darken-1"
      >
        {{ item.stateName || item.clientName }}
      </span>
    </template>

    <template v-slot:item.autoAssign="{ item }">
      <v-icon
          v-if="item.autoAssign"
          small
          color="success"
          title="Reaches matching clients without an attachment"
      >
        check_circle
      </v-icon>
      <span
          v-else
          class="grey--text"
          title="Only applies where attached by hand"
      >
        manual
      </span>
    </template>

    <template v-slot:item.currentVersion="{ item }">
      <template v-if="item.currentVersion">
        v{{ item.currentVersion.versionNumber }}
        <p class="mb-0">
          <small class="grey--text text--darken-1">
            {{ item.currentVersion.sourceFileName }},
            released {{ item.currentVersion.releasedAt | date }}
          </small>
        </p>
      </template>
      <span
          v-else
          class="error--text"
      >
        not published
      </span>
    </template>

    <template v-slot:item.isActive="{ item }">
      <v-simple-checkbox
          :value="item.isActive"
          style="pointer-events: none"
          disabled
      ></v-simple-checkbox>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-btn
          icon
          title="Versions"
          @click.stop="$emit('versions', item)"
      >
        <v-icon small>history</v-icon>
      </v-btn>
      <v-btn
          icon
          title="Delete"
          @click.stop="$emit('delete', item)"
      >
        <v-icon small>delete</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import SCHEMATRON_SCOPES from '@/enums/schematronScopes';

const SCOPE_COLORS = {
  [SCHEMATRON_SCOPES.NATIONAL]: 'indigo',
  [SCHEMATRON_SCOPES.STATE]: 'teal',
  [SCHEMATRON_SCOPES.COUNTY]: 'orange darken-2',
  [SCHEMATRON_SCOPES.CLIENT]: 'purple',
};

export default {
  name: 'SchematronsTable',
  filters: {
    date(value) {
      return value ? value.substring(0, 10) : '';
    },
  },
  props: {
    schematrons: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Scope', value: 'scope' },
        { text: 'Dataset', value: 'datasetType' },
        { text: 'NEMSIS', value: 'nemsisVersion' },
        { text: 'Auto assign', value: 'autoAssign' },
        { text: 'Published version', value: 'currentVersion', sortable: false },
        { text: 'Active', value: 'isActive' },
        {
          text: '', value: 'actions', sortable: false, align: 'end',
        },
      ],
    };
  },

  methods: {
    scopeColor(scope) {
      return SCOPE_COLORS[scope] || 'grey';
    },
  },
};
</script>
